import { type UseQueryResult, useQuery } from '@tanstack/react-query'
import { useTypedApiClient } from 'hooks/useTypedApiClient'
import { type components } from 'src/api/playerPayback/api'

export const useGetBadgeRewards = (): UseQueryResult<
  Array<components['schemas']['BadgeRewardDTO']>
> => {
  const get = useTypedApiClient({
    path: '/admin/badgerewards',
    method: 'get',
  })
  return useQuery({
    queryKey: ['/admin/badgerewards'],
    queryFn: async () => {
      const { data } = await get({})
      return data
    },
  })
}
